// extracted by mini-css-extract-plugin
module.exports = {"main":"ZQqo91","rows-1":"_1gQHpE","rows-2":"_3_6zme","rows-3":"_1NVGOM","rows-4":"_2eBqYD","size-l":"PNodrJ","size-m":"_2hiaSL","size-s":"_1pl0a_","size-xs":"_11TPs3"};